import { useQuery } from '@apollo/client/react';
import { useMemo } from 'react';

import { GetPatientPharmacistDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';

export const usePharmacistOptions = () => {
  const { loading, data } = useQuery(GetPatientPharmacistDocument, {
    notifyOnNetworkStatusChange: true,
  });

  const options = useMemo(() => {
    if (!data) return [];
    const practitioners = getMe(data)?.organization.pharmacistPractitioners || [];

    return practitioners.map((practitioner) => ({
      label: `${practitioner.familyName} ${practitioner.givenName}`,
      value: practitioner.id,
    }));
  }, [data]);

  return {
    loading,
    options,
  };
};
